























































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { IDRec, ChoiceOption } from '@/interfaces';

@Component
export default class DeviceTypeDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public url = this.getTableCfg(this.tableCfg, 'url');
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public items: IDRec[] = [];

  public headers = [
    {
      text: 'Naam',
      value: 'name'
    },
    {
      text: 'Type',
      value: 'linedatatype'
    },
    {
      text: 'Standaard',
      value: 'default'
    },
    {
      text: 'Titel NL',
      value: 'title_nl'
    },
    {
      text: 'Titel FR',
      value: 'title_fr'
    },
    {
      text: 'Items NL Count',
      value: 'values_cnt_nl'
    },
    {
      text: 'Items FR Count',
      value: 'values_cnt_fr'
    }
  ];

  public get isNew() {
    return this.$route.params.id === 'new';
  }

  public goToNewDeviceTypeLine() {
    const deviceTypeId = this.$route.params.id;
    this.$router.push('/devices/types/' + deviceTypeId + '/lines/new');
  }

  public get getDeviceTypeLineLink() {
    const deviceTypeId = this.$route.params.id;
    return '/devices/types/' + deviceTypeId + '/lines/';
  }

  public get roadTracksOptionList() {
    const roadTracks: ChoiceOption[] = [];
    for (let i = 1; i < 17; i++) {
      roadTracks.push({
        value: String(i),
        text: String(i)
      });
    }
    return roadTracks;
  }

  public initDeviceGroupId(rec) {
    if (rec.devicegroup_id) {
      this.setDeviceGroupID(rec.devicegroup_id);
    }
  }

  public async getDeviceTypeLines() {
    const id = this.$route.params.id;
    const response = await this.api.getLines(this.$store, '/devicetypes/' + id);
    if (response) {
      const items = response.data.data;
      this.items = items;
    }
  }

  public async DeviceTypeLinesChange(moved) {
    const id = this.$route.params.id;
    const order: number[] = [];
    for (const item of this.items) {
      order.push(item.id);
    }
    const response = await this.api.createRecord(
      this.$store,
      '/devicetypes/' + id + '/lines/set_order',
      {
        idlist: order
      }
    );
  }

  public async DeviceTypeLinesDelete(deletedId) {
    const id = this.$route.params.id;
    const response = await this.api.deleteRecord(
      this.$store,
      '/devicetypes/' + id + '/lines/' + String(deletedId)
    );
  }

  // Lifecycle Functions
  public created() {
    if (!this.isNew) {
      this.getDeviceTypeLines();
    }
  }
}
